import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { RemarksComponent } from './remarks/remarks.component';

@Component({
  selector: 'app-history-details',
  templateUrl: './history-details.component.html',
  styleUrls: ['./history-details.component.css'],
})
export class HistoryDetailsComponent implements OnInit {
  private HistoryApi = environment.url + 'preincubation/history?id=';
  private ApprovalApi = environment.url + environment.preincubaterapproval;
  /**
   * Constructs a new HistoryDetailsComponent.
   * @param data - The data passed from the parent component.
   * @param makeapi - The API service for making HTTP requests.
   * @param getdata - The value service for managing application values.
   * @param dialogRef - The reference to the dialog containing this component.
   * @param dialog - The dialog service for opening dialogs.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialogRef: MatDialogRef<HistoryDetailsComponent>,
    public dialog: MatDialog
  ) {}
  /**
   * Initializes the component.
   * Calls the History method to fetch the history of the application.
   */
  ngOnInit(): void {
    // Fetch the history of the application
    this.History();
  }
  role = sessionStorage.getItem('role');
  historyData;
  noData = false;
  /**
   * Fetches the history of the application from the API.
   * Updates the component's data on success.
   */
  History() {
    // Get the user ID from session storage
    let id = sessionStorage.getItem('userId');
    // Call the API to get the history of the application
    return this.makeapi
      .method(this.HistoryApi + id, '', 'get')
      .subscribe((data) => {
        // If the response contains history data, set noData to false and update the component's historyData
        if (data.preIncAppHistory) {
          this.noData = false;
          this.historyData = data.preIncAppHistory;
        } else {
          // If no history data is found, set noData to true
          this.noData = true;
        }
      });
  }
  /**
   * Sets the application as resolved.
   * Sends a request to the API to update the application status.
   * If the request is successful, it fetches the history of the application
   * and updates the component's data.
   */
  setReSolved() {
    this.getdata.amizhthLoader('show');
    let req = {
      // The user ID to update the application status
      userId: sessionStorage.getItem('userId'),
      // The status to update the application to
      status: 1,
    };
    // Call the API to update the application status
    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      // Hide the loading indicator after the API call is complete
      this.getdata.amizhthLoader('hide');
      // If the request was successful, fetch the history of the application
      // and update the component's data
      if (data.responseStatus == 'Success') {
        this.History();
      }
    });
  }
  /**
   * Cancels the current operation.
   * Closes the dialog without performing any action.
   */
  cancelReason() {
    this.dialogRef.close();
  }
  /**
   * Opens a dialog to display the remarks of a particular application.
   * The dialog takes the remarks as data and displays it.
   * @param val The remarks of the application.
   */
  remarksFun(val: string) {
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _data: val },
    });

    // Close the dialog and refresh the list of applications when the dialog is closed.
    dialogRef.afterClosed().subscribe((result) => {
      this.getdata.isVisibleSource.next(true);
    });
  }
}
